import React, { useContext } from "react";
import { EligibilityContext } from "../../contexts/EligibilityContext";

const CriteriaPicklist = ({ criteria, register, errors }) => {
  const context = useContext(EligibilityContext);
  const options = criteria.options.split(";");

  return (
    <fieldset className="u-mb4">
      <label htmlFor={`${criteria.name}`}>
        {criteria.criteria}

        {errors[criteria.name] && errors[criteria.name].type === "required" && (
          <span data-validate="error">Please make a selection.</span>
        )}
      </label>
      <select
        name={criteria.name}
        id={criteria.name}
        ref={register({ required: true })}
      >
        <option value="">Select</option>
        {options.map((option, index) => (
          <option
            key={index}
            value={JSON.stringify({
              criteria: criteria.criteria,
              fundId: context.state.diseaseFund.fundId,
              answerType: criteria.answerType,
              response: option,
              id: criteria.id,
              criteriaMetaDataName: criteria.criteriaMetaDataName,
            })}
          >
            {option}
          </option>
        ))}
      </select>
    </fieldset>
  );
};

export default CriteriaPicklist;
